import { api } from "@/shared/api/client";

export interface ProfileDTO {
    id: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    addressId?: string;
    country?: string;
    postalCode?: string;
    line1?: string;
    line2?: string;
    addressName?: string;
    state?: string;
    city?: string;
    district?: string;
}

export interface PageProfilesDTO {
    content: ProfileDTO[];
    totalElements: number;
    totalPages: number;
    size: number;
    number: number;
}

export interface ProfileFilter {
    firstName?: string;
    phoneNumber?: string;
    country?: string;
    state?: string;
    city?: string;
}

export const profileService = {
    getAll: async (params: {
        page: number;
        size: number;
        sort?: string[];
        filter?: ProfileFilter;
    }): Promise<PageProfilesDTO> => {
        const response = await api.get<PageProfilesDTO>("/profiles", {
            params: {
                "pageable.page": params.page - 1,
                "pageable.size": params.size,
                "pageable.sort": params.sort,
                "filter.firstName": params.filter?.firstName,
                "filter.phoneNumber": params.filter?.phoneNumber,
                "filter.country": params.filter?.country,
                "filter.state": params.filter?.state,
                "filter.city": params.filter?.city,
            },
        });
        return response.data;
    },

    getById: async (id: string): Promise<ProfileDTO> => {
        const response = await api.get<ProfileDTO>(`/profiles/${id}`);
        return response.data;
    },
};
